import React from 'react';

import { useIntl } from 'react-intl-next';

import { Box, Flex } from '@atlaskit/primitives/compiled';
import { ResponderAvatar, useResponderNames } from '@atlassian/eoc-responder-names';
import { VerifiedTeamIcon } from '@atlassian/people-teams-ui/verified-team-icon';

import { checkVerified, filterNoOne, getResponder } from '../../../../../utils/responder';
import { Row } from '../index';

import { type ReadonlyUserProps } from './types';
import { labelText } from './utils';

const ReadonlyUser = ({ responder, variant }: ReadonlyUserProps) => {
	const intlApi = useIntl();

	const [user] = useResponderNames(filterNoOne([responder]));

	const { name } = getResponder(responder, user, intlApi);

	const isNoOne = responder.type === 'noone';

	const isVerified = checkVerified(user);

	return (
		<Row variant="inline" label={labelText(intlApi)[variant]}>
			<Flex alignItems="center" columnGap="space.100">
				{!isNoOne && <ResponderAvatar responder={user} size="small" appearance="circle" />}
				<Box as="span">{name}</Box>
				{isVerified && <VerifiedTeamIcon />}
			</Flex>
		</Row>
	);
};

export { ReadonlyUser };
